import * as React from "react";
import { createSvgIcon } from "@material-ui/core";
import { tokens } from "../theme/tokens";

export default createSvgIcon(
  <path
    d="M13.495-.005c-7.457 0-13.5 6.043-13.5 13.5 0 7.458 6.043 13.5 13.5 13.5 7.458 0 13.5-6.043 13.5-13.5s-6.043-13.5-13.5-13.5zm5.874 14.539h-4.835v4.835c0 .571-.468 1.038-1.039 1.038a1.032 1.032 0 0 1-.733-.305 1.036 1.036 0 0 1-.306-.733v-4.835H7.622a1.032 1.032 0 0 1-.733-.306 1.036 1.036 0 0 1 .733-1.771h4.835V7.62c0-.571.468-1.038 1.039-1.038s1.039.467 1.039 1.038v4.835h4.835c.571 0 1.038.468 1.038 1.039s-.467 1.039-1.038 1.039z"
    fill={tokens.color.brand.primary}
    fillRule="evenodd"
  />,
  "NewCase"
);
